import React from 'react';
import { Stack, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { useParameterizedQuery, useMutation } from 'react-fetching-library';
import { getEmployeeDocumentsAction, sendEmployeeDocument, sendSetOfEmployeeDocumentsAction } from '../../../../../../services/request';
import AgreementButton from './AgreementButton';
import DocumentButton from './DocumentButton';
import PDFPreviewModal from './PDFPreviewModal';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useApplication } from '../../../ApplicationsContext';

import SendMessagePreviewModalWithFiles from './SendMessagePreviewModalWithFiles';
import toast from 'react-hot-toast';

import { functions } from '../../../functions';

const DocumentsButtons = ({ formik }) => {
  const application = formik.values;
  const [openPreviewModal, setOpenPreviewModal] = React.useState(false);
  const [previewUrl, setPreviewUrl] = React.useState(null);
  const { module, seasonIdentifier } = useSelector(state => state.app);
  const { mutate } = useMutation(sendEmployeeDocument);
  const { query } = useParameterizedQuery(getEmployeeDocumentsAction);
  const { query: sendAllQuery } = useParameterizedQuery(sendSetOfEmployeeDocumentsAction);
  const ctx = useApplication();


  const handleClick = async (template_name, fileName, annex_id = 0, preview = false, id = application.id) => {
    const { payload, error, loading } = await query(id, template_name, fileName, annex_id);

    if (!error && !loading) {
      if (preview) {
        setPreviewUrl(window.URL.createObjectURL(payload));
      } else {
        const url = window.URL.createObjectURL(payload);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = `${fileName}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    }
  };

  const handleSend = async (template_name, data, documentName) => {
    const { error, loading } = await mutate(application.id, template_name, data, documentName);

    if (error) {
      toast.error('Nie udało się wysłać dokumentu');
    }
  };

  const handleSendAll = async data => {
    const { error, loading } = await sendAllQuery(application.id, data);
    if (!error && !loading) {
      toast.success('Komplet dokumentów został wysłany');
      setOpenPreviewModal(false);
    }

    if (error) {
      toast.error('Nie udało się wysłać kompletu dokumentów');
    }
  };

  const handleDownloadAll = async () => {
    await console.log('Download');
    // if (order.order_annexes.length > 0) {
    //   const annex = order.order_annexes[order.order_annexes.length - 1];
    //   await handleClick('agreement_annex', `Aneks nr ${annex.number} do umowy ${order.agreement_number}`, annex.id);
    // } else {
    //   await handleClick('agreement', 'umowa');
    // }
    // await handleClick('qualification_card', 'karta kwalifikacyjna');
    // await handleClick('terms_of_participation', 'warunki uczestnictwa');
    // await handleClick('clauses', 'Klauzule inf.odo do umowy_organizacja wypoczynku_SunSport');
  };

  const handleOpenPreviewModal = () => setOpenPreviewModal(true);
  const handleClosePreviewModal = () => setOpenPreviewModal(false);

  const handleChangeState = () => {
    ctx.handleChangeStateCallback([functions.INSTRUCTORASSIST, functions.PHOTOGRAPHER, functions.PHOTOGRAPHER_ZS].includes(Number(application.function_type)) ? 'AGS' : 'AGS'); // IA, PHOTO, PHOTO_ZS
  };


  const filenames = {
    'agreement': application.agreement_number,
    'agreement_attachment': 'Załączniki do umowy',
    'ppk_info': 'Informacja PPK',
    'ppk_resignation': 'Rezygnacja PPK',
    'pit': 'Oświadczenie PIT',
    'citizenship': 'Oświadczenie o obywatelstwie i miejscu zamieszkania'
  };
  if (![functions.INSTRUCTORASSIST, functions.NURSE].includes(Number(application.function_type))) {
    filenames.bonus_regulations = 'Regulamin bonusów';
  };

  if ([functions.INSTRUCTORASSIST].includes(Number(application.function_type))) {
    const keysToRemove = ['ppk_info', 'ppk_resignation', 'citizenship'];
    keysToRemove.forEach(key => {
      Reflect.deleteProperty(filenames, key);
    });
  };

  return (
    <Stack direction="row" alignItems="flex-start" justifyContent="space-between">
      <AgreementButton formik={formik} getDocument={handleClick} module={module}/>
      <DocumentButton
        name="Załączniki do umowy"
        application = {application}
        disabled={application.agreement_number == ''}
        handleDownload={() => handleClick('attachments', `Załączniki do umowy ${application.agreement_number}`)}
        handleShow={() => handleClick('attachments', `Załączniki do umowy ${application.agreement_number}`, 0, true)}
        handleSend={data => handleSend('attachments', data, `Załączniki do umowy ${application.agreement_number}`)}
      />
      <DocumentButton
        name="Informacja PPK"
        disabled={application.agreement_number == ''}
        handleDownload={() => handleClick('PPK_info', `Informacja PPK ${application.agreement_number}`)}
        handleShow={() => handleClick('PPK_info', `Informacja PPK ${application.agreement_number}`, 0, true)}
        handleSend={data => handleSend('PPK_info', data, `Informacja PPK ${application.agreement_number}`)}
      />
      <DocumentButton
        name="Rezygnacja PPK"
        disabled={application.agreement_number == ''}
        handleDownload={() => handleClick('PPK_resignation', `Rezygnacja PPK ${application.agreement_number}`)}
        handleShow={() => handleClick('PPK_resignation', `Rezygnacja PPK ${application.agreement_number}`, 0, true)}
        handleSend={data => handleSend('PPK_resignation', data, `Rezygnacja PPK ${application.agreement_number}`)}
      />
      <Stack gap={2} alignItems="center">
        <DocumentButton
          name="Regulamin bonusów"
          disabled={application.agreement_number == ''}
          handleDownload={() => handleClick('bonus_regulations', 'Regulamin bonusów')}
          handleShow={() => handleClick('bonus_regulations', 'Regulamin bonusów', 0, true)}
          handleSend={data => handleSend('bonus_regulations', data, 'Regulamin bonusów')}
        />
        {/* <DocumentButton
          name="Szczepienie COVID"
          disabled={application.agreement_number == ''}
          handleDownload={() => handleClick('covid_vaccination', 'Szczepienie COVID')}
          handleShow={() => handleClick('covid_vaccination', 'Szczepienie COVID', 0, true)}
          handleSend={data => handleSend('covid_vaccination', data, 'Szczepienie COVID')}
        /> */}
      </Stack>
      <Button
        variant="contained"
        disabled={application.agreement_number == '' || seasonIdentifier == 'l_23_rekrutacja'}
        onClick={application.way_of_sending_contract === 'traditional_mail' ? handleDownloadAll : handleOpenPreviewModal}
        endIcon={application.way_of_sending_contract === 'traditional_mail' ? <FileDownloadIcon /> : <AttachEmailIcon />}
      >
        {application.way_of_sending_contract === 'traditional_mail'
          ? 'Pobierz dokumenty'
          : 'Wyślij komplet dokumentów'}
      </Button>

      {previewUrl !== null ? <PDFPreviewModal url={previewUrl} handleClose={() => setPreviewUrl(null)}/> : null}
      {openPreviewModal
        ? <SendMessagePreviewModalWithFiles
          key={openPreviewModal}
          handleSend={handleSendAll}
          handleClose={handleClosePreviewModal}
          fileNames={filenames}
          type={
            [
              functions.INSTRUCTORASSIST,
              functions.PHOTOGRAPHER,
              functions.PHOTOGRAPHER_ZS
            ].includes(Number(application.function_type))
              ? 'SSOD'
              : 'SSOS'
          }
          additionalAction={handleChangeState}
        />
        : null}
    </Stack>
  );
};

export default DocumentsButtons;
